import React, { useEffect, useMemo, useState } from 'react';
import MasterService from '../services/master/MasterService';

const CaraAngkut = ({id}) => {
    let masterService = useMemo(() => new MasterService(), [])
    const [caraAngkut, setCaraAngkut] = useState('')

    useEffect(() => {
        const getCaraAngkut = async () => {
            const response = await masterService.getCaraAngkutById(id)
            setCaraAngkut(response.data.caraAngkut)
        }
        getCaraAngkut()
    }, [masterService, id])

    return (
        <>
            {caraAngkut}
        </>
    )
}

export default CaraAngkut